import React from 'react'

import { AsyncSelect } from '_zari/core'

import * as CentroCostoService from 'services/centrosCosto.service'

const Select2CentroCostoNivel2 = ({ id, onChange, idNodoPadre }) => {
  const loadCentrosSelect = React.useCallback(
    (inputValue, resolve) => {
      CentroCostoService.obtenerNivel2xIdNodoPadreAsSelect2({
        busqueda: inputValue,
        idNodoPadre: idNodoPadre
      })
        .then(({ data }) => resolve(data))
        .catch(() => resolve([]))
    },
    [idNodoPadre]
  )

  return <AsyncSelect selectId={id} loadOptions={loadCentrosSelect} onChange={onChange} />
}

export default React.memo(Select2CentroCostoNivel2)
